import { theme } from "@src/theme";
import React from "react";
import styled from "styled-components";
import { ChevronDown, ChevronRight } from "lucide-react";

type DropDownTab = {
  title: string;
  active: boolean;
  children: React.ReactNode;
  onClick: () => void;
};

const StyledDropDownTab = styled.div<{ active: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
`;
const ContentContainer = styled.div<{ active: boolean }>`
  display: ${({ active }): string => (active ? "flex" : "none")};
  flex-direction: column;
  padding: ${theme.margins.small};

  background-color: ${theme.colors.darkBg};
  user-select: none;
`;
const TitleContainer = styled.div<{ active: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-top: ${theme.margins.small};
  padding-bottom: ${theme.margins.small};
  color: ${theme.colors.gray};

  border-bottom: 1px solid ${theme.colors.yellow};
  background-color: ${theme.colors.gray300};
  cursor: pointer;
  user-select: none;
`;

type DropDownTabProps = {
  isOpen: boolean;
  closeDropdown: () => void;
  openDropdown: () => void;
  toggleDropdown: () => void;
  children: React.ReactNode;
  secondaryTitleComponent?: React.ReactNode;
  title: string;
  titleContainerStyles?: React.CSSProperties;
  titleStyles?: React.CSSProperties;
  contentContainerStyles?: React.CSSProperties;
};
const DropDownTab = ({
  secondaryTitleComponent,
  contentContainerStyles,
  isOpen,
  toggleDropdown,
  children,
  title,
  titleContainerStyles,
  titleStyles,
}: DropDownTabProps) => {
  return (
    <StyledDropDownTab active={isOpen}>
      <TitleContainer
        style={{
          ...titleContainerStyles,
        }}
        onClick={toggleDropdown}
        active={isOpen}
      >
        <span
          style={{
            ...titleStyles,
          }}
        >
          {title}
        </span>
        <span style={{ display: "flex", alignItems: "center" }}>
          {secondaryTitleComponent && <>{secondaryTitleComponent}</>}
          {isOpen ? (
            <ChevronDown size={20} />
          ) : (
            <ChevronRight fontWeight={600} size={20} />
          )}
        </span>
      </TitleContainer>
      <ContentContainer
        style={{
          ...contentContainerStyles,
        }}
        active={isOpen}
      >
        {children}
      </ContentContainer>
    </StyledDropDownTab>
  );
};

export default DropDownTab;
